'use client';

import Image from 'next/image';
import { BlocksRenderer, type BlocksContent } from '@strapi/blocks-react-renderer';
import { handleUseStrapiImageUrl } from 'helpers/strapi';
export default function BlockRendererClient({
  content
}: {
  readonly content: BlocksContent;
}) {
  if (!content) return null;
  return <BlocksRenderer content={content} blocks={{
    image: ({
      image
    }) => {
      return <Image src={handleUseStrapiImageUrl(image.url)} width={image.width} height={image.height} alt={image.alternativeText || ''} />;
    },
    paragraph: ({
      children
    }) => <p className="mb-6 text-justify">{children}</p>,
    heading: ({
      level,
      children
    }) => {
      let component;
      switch (level) {
        case 1:
          component = <h1 className="text-xl font-semibold">{children}</h1>;
          break;
        case 2:
          component = <h2 className="text-lg font-semibold mb-6">{children}</h2>;
          break;
        case 3:
          component = <h3 className="text-md font-semibold mb-4">{children}</h3>;
          break;
      }
      return component;
    },
    link: ({
      url,
      children
    }) => {
      return <a className="underline" href={url} target="_blank">
              {children}
            </a>;
    }
  }} data-sentry-element="BlocksRenderer" data-sentry-component="BlockRendererClient" data-sentry-source-file="BlockRendererClient.tsx" />;
}